function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint0_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint1_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 38,
  height: 38
}, /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "#C4C4C4"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 19,
  cy: 19,
  r: 19,
  fill: "white"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3332 19.9838C18.1754 19.9838 18.0334 19.9024 17.9387 19.772C17.7966 19.544 17.844 19.2507 18.0649 19.0878L29.8387 10.9581C30.0596 10.8115 30.3437 10.8604 30.5015 11.0884C30.6436 11.3165 30.5962 11.6098 30.3753 11.7727L18.5857 19.9024C18.5068 19.9676 18.4121 19.9838 18.3332 19.9838Z",
  fill: "#FFCD01"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1726 15.6992C24.1569 15.6992 24.1411 15.6992 24.1253 15.6992C23.8728 15.6666 23.6834 15.4385 23.6992 15.1616L24.0306 11.8217C24.0622 11.5611 24.2831 11.3493 24.5514 11.3819C24.8039 11.4144 24.9933 11.6425 24.9775 11.9195L24.6461 15.2593C24.6145 15.52 24.4094 15.6992 24.1726 15.6992Z",
  fill: "#FFCD01"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24.5041 12.3595C24.3463 12.3595 24.2043 12.278 24.1096 12.1477C23.9675 11.9196 24.0149 11.6263 24.2358 11.4634L29.3178 7.8629C29.5387 7.71627 29.8228 7.76515 29.9807 7.99323C30.1227 8.22132 30.0753 8.51458 29.8544 8.6775L24.7724 12.2617C24.6935 12.3269 24.5988 12.3595 24.5041 12.3595Z",
  fill: "#FFCD01"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M30.1071 11.8706C29.8861 11.8706 29.6809 11.7077 29.6336 11.4633L29.1128 8.31899C29.0654 8.05831 29.239 7.79764 29.4916 7.74877C29.7441 7.69989 29.9966 7.8791 30.0439 8.13977L30.5648 11.2841C30.6121 11.5448 30.4385 11.8055 30.186 11.8543C30.1544 11.8543 30.1386 11.8706 30.1071 11.8706Z",
  fill: "#FFCD01"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5502 17.019C27.5029 17.019 27.4713 17.019 27.4239 17.0027L24.299 16.0904C24.0465 16.0089 23.9044 15.7482 23.9676 15.4876C24.0465 15.2269 24.299 15.0803 24.5515 15.1454L27.6765 16.0578C27.929 16.1392 28.071 16.3999 28.0079 16.6606C27.9605 16.8887 27.7712 17.019 27.5502 17.019Z",
  fill: "#FFCD01"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M27.5659 17.0353C27.4081 17.0353 27.266 16.9538 27.1713 16.8235C27.0293 16.5954 27.0924 16.3021 27.2976 16.1392L32.4269 12.6039C32.6479 12.4572 32.932 12.5224 33.0898 12.7342C33.2318 12.9623 33.1687 13.2555 32.9635 13.4185L27.8342 16.9538C27.7553 17.0027 27.6606 17.0353 27.5659 17.0353Z",
  fill: "#FFCD01"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M32.7268 13.5163C32.6478 13.5163 32.5532 13.5 32.4742 13.4511L29.8386 11.7893C29.6176 11.6427 29.5387 11.3494 29.6807 11.1213C29.8228 10.8933 30.1069 10.8118 30.3278 10.9584L32.9635 12.6202C33.1844 12.7668 33.2634 13.0601 33.1213 13.2882C33.0424 13.4348 32.8846 13.5163 32.7268 13.5163Z",
  fill: "#FFCD01"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2862 24.4479C15.6979 24.4479 13.583 22.2648 13.583 19.5929C13.583 16.921 15.6979 14.7379 18.2862 14.7379C19.2016 14.7379 20.0854 15.0149 20.843 15.5199C21.0639 15.6666 21.127 15.9761 20.985 16.1879C20.843 16.416 20.5431 16.4812 20.3221 16.3345C19.7066 15.9272 19.0122 15.7154 18.2862 15.7154C16.2187 15.7154 14.53 17.4587 14.53 19.5929C14.53 21.7271 16.2187 23.4704 18.2862 23.4704C20.3537 23.4704 22.0424 21.7271 22.0424 19.5929C22.0424 19.4137 22.0266 19.2182 22.0109 19.039C21.9793 18.7783 22.1529 18.5176 22.4212 18.4851C22.6737 18.4525 22.9263 18.6317 22.9578 18.9086C22.9894 19.1367 23.0052 19.3648 23.0052 19.5929C22.9894 22.2648 20.8745 24.4479 18.2862 24.4479Z",
  fill: "#FFCD01"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M18.286 29.0261C13.2514 29.0261 9.14795 24.7902 9.14795 19.5931C9.14795 14.3959 13.2514 10.16 18.286 10.16C19.9748 10.16 21.6161 10.6325 23.0523 11.5448C23.2733 11.6915 23.3522 11.9847 23.2102 12.2128C23.0681 12.4409 22.784 12.5224 22.5631 12.3757C21.2847 11.5611 19.8011 11.1375 18.286 11.1375C13.7722 11.1375 10.0949 14.9336 10.0949 19.5931C10.0949 24.2525 13.7722 28.0486 18.286 28.0486C22.7998 28.0486 26.4772 24.2525 26.4772 19.5931C26.4772 19.1206 26.4456 18.6644 26.3667 18.2082C26.3193 17.9476 26.4929 17.6869 26.7612 17.6543C27.0138 17.6054 27.2663 17.7847 27.2978 18.0616C27.3768 18.5667 27.4241 19.088 27.4241 19.6094C27.4083 24.7902 23.3206 29.0261 18.286 29.0261Z",
  fill: "#FFCD01"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2173 19.5929C19.2173 20.1306 18.807 20.5542 18.2861 20.5542C17.7653 20.5542 17.355 20.1306 17.355 19.5929C17.355 19.0553 17.7653 18.6317 18.2861 18.6317C18.7912 18.6317 19.2173 19.0553 19.2173 19.5929Z",
  fill: "#FFCD01"
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 14.1655,
  y1: 18.9967,
  x2: 39.846,
  y2: 18.9967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C800CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 32.8453,
  y1: -3.12632,
  x2: 17.8651,
  y2: 33.1345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003FBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#1E39C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3B33C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#532ECA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#662ACC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7327CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7B25CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 14.1655,
  y1: 18.9967,
  x2: 39.846,
  y2: 18.9967,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C800CA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 32.8453,
  y1: -3.12632,
  x2: 17.8651,
  y2: 33.1345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#003FBF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#1E39C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#3B33C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#532ECA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#662ACC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#7327CE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#7B25CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D25CF"
})));

function SvgMarketingActive(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

export default "data:image/svg+xml;base64,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";
export { SvgMarketingActive as ReactComponent };